import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Box, Container, Typography, Grid } from "@mui/material";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

const About = () => {
  useEffect(() => {
    AOS.init({ duration: 800, easing: "ease-out", once: true, offset: 100 });
  }, []);

  return (
    <>
      <Navbar />
      <Container maxWidth="lg" sx={{ pt: 6, pb: 10 }}>
        {/* ABOUT US Label */}
        <Typography
          data-aos="fade-up"
          sx={{
            color: "#888",
            fontWeight: 700,
            fontSize: "1rem",
            letterSpacing: 1.5,
            mb: 2,
            fontFamily: "Gilroy, sans-serif",
            textTransform: "uppercase",
          }}
        >
          ABOUT US
        </Typography>

        {/* Main Heading */}
        <Typography
          data-aos="fade-up"
          data-aos-delay="150"
          variant="h2"
          sx={{
            fontFamily: "Monument-Private",
            fontWeight: 700,
            fontSize: { xs: "2.5rem", md: "3.5rem" },
            mb: 4,
            lineHeight: 1.1,
          }}
        >
          Let's tell you
          <br />
          our story
        </Typography>

        {/* Story Section (large rounded box) */}
        <Box
          data-aos="fade-up"
          data-aos-delay="300"
          sx={{
            backgroundColor: "#f4f5f7",
            borderRadius: 6,
            minHeight: 300,
            mb: 8,
            px: { xs: 2, sm: 6, md: 10 },
            py: { xs: 6, sm: 8 },
            display: "flex",
            alignItems: "center",
            fontSize: "1.1rem",
            backgroundImage: "url(/about-bg.jpeg)",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></Box>

        {/* Our Mission Section */}
        <Grid container spacing={0} alignItems="flex-start">
          <Grid item size={{ xs: 12, md: 4 }}>
            <Typography
              data-aos="fade-up"
              data-aos-delay="400"
              variant="h3"
              sx={{
                fontFamily: "Monument-Private",
                fontWeight: 700,
                fontSize: { xs: "2rem", md: "2.2rem" },
                mb: { xs: 2, md: 0 },
              }}
            >
              Our Mission
            </Typography>
          </Grid>
          <Grid item size={{ xs: 12, md: 8 }}>
            <Typography
              data-aos="fade-up"
              data-aos-delay="500"
              sx={{
                color: "#444",
                fontSize: "1rem",
                mb: 2,
              }}
            >
              For over nine years, we’ve been redefining what it means to feel
              truly at home while on holiday. Based in Goa, our mission is to
              offer exceptional stays that combine the warmth and comfort of a
              private home with the indulgence and service of a five-star
              resort.
            </Typography>

            <Typography
              data-aos="fade-up"
              data-aos-delay="500"
              sx={{
                color: "#444",
                fontSize: "1rem",
                mb: 2,
              }}
            >
              With over 30,000 guests hosted and a remarkable 60% return rate,
              our commitment to quality speaks for itself. Rated 4.8 out of 5
              across platforms, we’ve built lasting relationships by delivering
              consistently memorable experiences. Whether it’s your first visit
              or your fifth, we’re here to make every stay better than the last.
            </Typography>
          </Grid>
        </Grid>

        {/* TEAM SECTION */}
        <Box sx={{ mt: { xs: 8, md: 20 } }}>
          <Typography
            data-aos="fade-up"
            sx={{
              color: "#888",
              fontWeight: 700,
              fontSize: "1rem",
              letterSpacing: 1.5,
              fontFamily: "Gilroy, sans-serif",
              textTransform: "uppercase",
            }}
          >
            TEAM
          </Typography>
          <Typography
            data-aos="fade-up"
            data-aos-delay="100"
            variant="h3"
            sx={{
              fontFamily: "Monument-Private",
              fontWeight: 700,
              fontSize: { xs: "2rem", md: "3rem" },
              mb: 4,
            }}
          >
            Meet the minds
          </Typography>
          <Grid container spacing={{ xs: 2, sm: 4 }}>
            {["Kevin", "Amster", "Alyster", "Nagamesh"].map((name, idx) => (
              <Grid item size={{ xs: 6, md: 3 }} key={name}>
                <Box
                  data-aos="fade-up"
                  data-aos-delay={200 + idx * 100}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: "#f4f5f7",
                      borderRadius: 4,
                      width: "100%",
                      aspectRatio: "1/1",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mb: 1,
                      backgroundImage: `url(/${name.toLowerCase()}.jpg)`,
                      backgroundSize: "cover",
                    }}
                  />
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontFamily: "Monument-Private",
                      mt: 1,
                      textAlign: "center",
                    }}
                  >
                    {name}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* HEADQUARTERS SECTION (Google Maps embed) */}
        <Box sx={{ mt: { xs: 8, md: 12 } }}>
          <Typography
            data-aos="fade-up"
            sx={{
              color: "#888",
              fontWeight: 700,
              fontSize: "1rem",
              letterSpacing: 1.5,
              fontFamily: "Gilroy, sans-serif",
              textTransform: "uppercase",
            }}
          >
            HEADQUARTERS
          </Typography>
          <Typography
            data-aos="fade-up"
            data-aos-delay="100"
            variant="h3"
            sx={{
              fontFamily: "Monument-Private",
              fontWeight: 700,
              fontSize: { xs: "2rem", md: "3rem" },
              mb: 4,
            }}
          >
            Where to find us?
          </Typography>
          <Box
            data-aos="fade-up"
            data-aos-delay="200"
            sx={{
              width: "100%",
              mx: "auto",
              borderRadius: 4,
              overflow: "hidden",
              boxShadow: 1,
              background: "#f4f5f7",
            }}
          >
            <Box
              sx={{
                position: "relative",
                width: "100%",
                height: { xs: 260, md: 380 },
              }}
            >
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3845.1678181334582!2d73.80780247570375!3d15.475402785121352!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbfc1fee36149b9%3A0x417f4ac32d1ec6f5!2sAspire%20Ventures%20Hospitality!5e0!3m2!1sen!2sin!4v1752052497355!5m2!1sen!2sin"
                width="100%"
                height="450"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </Box>
          </Box>
        </Box>
      </Container>
      <Footer />
    </>
  );
};

export default About;
